define('lq/events/actions/cqExecutionCommand',[
    'lq/events/actions/eventAction'
], function (EventAction) {
    'use strict';

    function CQExecutionCommand(eventData, eventArg) {
        EventAction.call(this, eventData, eventArg);
        return this;
    }

    EventAction.extend(CQExecutionCommand, EventAction);

    CQExecutionCommand.typeName = 'CQExecutionCommand';

    CQExecutionCommand.prototype.getBatchType = function () {
        return EventAction.COMMAND_BATCH;
    };

    CQExecutionCommand.prototype.createEventActionRequest = function () {
        return {
            eventActionType: 'CQExecutionCommand',
            command: this.eventData.command
        };
    };

    CQExecutionCommand.prototype.execute = function (continuation, eventActionResponse) {
        if (eventActionResponse.isDirty)
            this.handleExecutionTrailDirty(continuation);
        else continuation();
    };
    
    return CQExecutionCommand;
});
